<template>
<div class="chapter">
<div class="inner_page">
<p class="ser"><img alt="srilanka1" id="d12de78" src="images/srilanka1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Morr_9780310252344_epub_c1_r1.vue?a7a12214